import App from "../app";
import Home from "../pages/home";
import Choir from "../pages/choir";
import Moderation from "../../pages/moderation";
import Signup from "../../pages/signup";
import Login from "../../pages/login";
import SignupProfile from "../../memory/pages/signup-profile";
import Terms from "../pages/terms";
import Account from "../../pages/account";
import Privacy from "../../pages/privacy";
import Contact from "../../pages/contact";
import PasswordRecovery from "../../pages/password-recovery";
import Verify from "../../pages/verify";
import NotFound from "../pages/404";
import routing from "../../routing";
import Dashboard from "../pages/dashboard";
import PreRegistration from "../pages/pre-registration";
import ChoirHome from "../pages/choir-home";

export default [
    {
        ...App,
        path: `/${routing.choir}`,
        routes: [
            {
                ...Home,
                path: `/${routing.choir}`,
                exact: true,
            },
            {
                ...Login,
                path: `/${routing.choir}/${routing.login}`,
            },
            {
                ...ChoirHome,
                path: `/${routing.choir}/${routing.choirHome}`,
                exact: true,
            },
            {
                ...PreRegistration,
                path: `/${routing.choir}/${routing.choirPreRegistration}`,
            },
            {
                ...Dashboard,
                path: [
                    `/${routing.choir}/${routing.dashboard}`,
                    `/${routing.choir}/${routing.choir}/:id`,
                ],
            },
            {
                ...Moderation,
                path: `/${routing.choir}/${routing.moderation}`,
            },
            {
                ...Signup,
                path: `/${routing.choir}/${routing.signup}`,
            },
            {
                ...Terms,
                path: `/${routing.choir}/${routing.terms}`,
            },
            {
                ...SignupProfile,
                path: `/${routing.choir}/${routing.signupProfile}`,
            },
            {
                ...Account,
                path: `/${routing.choir}/${routing.account}`,
            },
            {
                ...Privacy,
                path: `/${routing.choir}/${routing.privacy}`,
            },
            {
                ...Contact,
                path: `/${routing.choir}/${routing.contact}`,
            },
            {
                ...PasswordRecovery,
                path: `/${routing.choir}/${routing.passwordRecovery}`,
            },
            {
                ...Verify,
                path: `/${routing.choir}/${routing.verify}`,
            },
            {
                ...Choir,
                path: `/${routing.choir}/:id`
            },
            {
                ...NotFound,
            },
        ],
    },
];
